module.exports = __webpack_public_path__ + "fonts/a4d31128b633bc0b1cc1f18a34fb3851.woff2";